import { render } from "./company-achievement.vue?vue&type=template&id=7e674e2a&scoped=true"
import script from "./company-achievement.vue?vue&type=script&lang=js"
export * from "./company-achievement.vue?vue&type=script&lang=js"

import "./company-achievement.vue?vue&type=style&index=0&id=7e674e2a&scoped=scoped&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e674e2a"]])

export default __exports__